export default {
  namespaced: true,
  state: {
    // "https://ts1.cn.mm.bing.net/th/id/R-C.19c943c6ec5fc1e94957ac5cddbbc285?rik=LsTWuif8n8er5g&riu=http%3a%2f%2fwww.jshkdl.cn%2fuploads%2fimage%2f20201204%2f1607065117805626.jpg&ehk=7SYimbhYJBK2n3LErY9geAZZaK1zuLd3zgldMmw%2fEPE%3d&risl=&pid=ImgRaw&r=0",
    report: [],
    other: [],
    urls: [],
  },
  mutations: {
    addReport(state, base64) {
      // state.report.push(base64);
      if (!state.report.includes(base64)) {
        state.report.push(base64);
      }
    },
    addOther(state, base64) {
      // state.other.push(base64);
      if (!state.other.includes(base64)) {
        state.other.push(base64);
      }
    },
    addUrl(state, base64) {
      // state.urls.push(base64);
      if (!state.urls.includes(base64)) {
        state.urls.push(base64);
      }
    },
    removeReport(state) {
      state.report.splice(0);
    },
    removeOther(state) {
      state.other.splice(0);
    },
    removeUrl(state) {
      state.urls.splice(0);
    },
    clearUrls(state) {
      state.urls = [];
    },
  },
  actions: {
    async addReport({ commit }, url) {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error("Failed to fetch image");
        }
        const blob = await response.blob();
        const reader = new FileReader();
        reader.onload = () => {
          // const base64 = reader.result;
          // commit("addUrl", base64);
          commit("addReport", url);
        };
        reader.readAsDataURL(blob);
      } catch (error) {
        console.warn(error);
      }
    },
    async addOther({ commit }, url) {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error("Failed to fetch image");
        }
        const blob = await response.blob();
        const reader = new FileReader();
        reader.onload = () => {
          // const base64 = reader.result;
          // commit("addUrl", base64);
          commit("addOther", url);
        };
        reader.readAsDataURL(blob);
      } catch (error) {
        console.warn(error);
      }
    },
    async addUrl({ commit }, url) {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error("Failed to fetch image");
        }
        const blob = await response.blob();
        const reader = new FileReader();
        reader.onload = () => {
          // const base64 = reader.result;
          // commit("addUrl", base64);
          commit("addUrl", url);
        };
        reader.readAsDataURL(blob);
      } catch (error) {
        console.warn(error);
      }
    },
    clearUrls({ commit }) {
      commit("clearUrls");
    },
  },
  getters: {
    getAllReport(state) {
      return state.report;
    },
    getAllOther(state) {
      return state.other;
    },
    getAllUrls(state) {
      return state.urls;
    },
  },
};
